import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-flows-by-actions',
    templateUrl: './flows-by-actions.component.html',
    styleUrls: ['./flows-by-actions.component.css'],
    standalone: false
})
export class FlowsByActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
